export default __webpack_public_path__ + "static/media/CC_logo_Primary_red.485b660d.png";